"use client"

import React, { useState, useEffect, useRef } from "react";
import {
    Row,
    Col,
    message,
    ProTableOt, 
    Form,
    useProTableOt,
    setParamsFilter,
    Button,
    useRelativeTime
} from "../../ui/ot";
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import { useTranslation } from "react-i18next";
import {  useNavigate } from "react-router-dom";
import { Card, CardContent } from "../../ui/card"
import { Info,   } from "lucide-react";
import useWindowSize from "../../online_public_catalog_query_construction/controllers/window_size";
const MessageInbox = ({ }) => {
  
    return (
        <Row>
            <Col span={24}>
                <MessageInboxTable />
            </Col>
        </Row>
    )
}

const MessageInboxTable = ({
    rowKey = "key",
    keyPrefix = "library.message_notification",
    showAllColumns = true,
    propsShowColumns,
    propslist_id,
    rowSelectType = 'checkbox',
    defaultSelectkeys = [], //selectkeys
    defaultSelectInfos = [], //selectInfo
    onSelectChange = () => { }//selectInfo
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [tableSearchParams, setTableSearchParams] = useState({
        list_id: propslist_id || null,
        // start_planneddate: dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
        // end_planneddate: dayjs().endOf('month').format('YYYY-MM-DD HH:mm:ss'),
    });
    const columns = [
        {
            title: 'account',
            // title: t("staff_name"),
            key: "account",
            dataIndex: "account",
            sorter: false,

        },
        {
            title: "staff_name",
            // title: t("staff_name"),
            key: "staff_name",
            dataIndex: "staff_name",
            sorter: false,

        },
        {
            title: "title",
            // title: t("title"),
            key: "title",
            dataIndex: "title",
            sorter: false,

        },
        {
            title: "content",
            // title: t("content"),
            key: "content",
            dataIndex: "content",
            sorter: false,

        },
        {
            title: "date_and_time",
            // title: t("date_and_time"),
            key: "date_and_time",
            dataIndex: "date_and_time",
            sorter: false,

        },

    ];
    const [showColumns, setShowColumns] = useState(propsShowColumns ? propsShowColumns : [])
    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(20);
    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectkeys ? defaultSelectkeys : []);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectInfos ? defaultSelectInfos : []);
     
    const [modalOpen, setModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [form] = Form.useForm();

    const navigate = useNavigate()


    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success(t('add_success'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.success(t('modify_success'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success(t('delete_success'));
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([]);
                setSelectedRowsInfo([]);
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error(t('add_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error(t('modify_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error(t('delete_failure'));
                actionRef.current.reloadAndRest();
            }
        }
        if (axiosMode !== "get") {
            setModalLoading(false);
            setModalOpen(false);
        }

    };
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true);
    };
    const showCard = {
        xxl: 2,
        xl: 2,
        lg: 2,
        md: 2,
        sm: 2,
        xs: 1,
    }
    // 螢幕大小斷點判斷
    function getBreakpoint(width) {
        const breakpoints = {
            xxl: 1600,
            xl: 1200,
            lg: 992,
            md: 768,
            sm: 576,
            xs: 0,
        };
        if (width >= breakpoints.xxl) return 'xxl';
        if (width >= breakpoints.xl) return 'xl';
        if (width >= breakpoints.lg) return 'lg';
        if (width >= breakpoints.md) return 'md';
        if (width >= breakpoints.sm) return 'sm';
        return 'xs';
    }

    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns,
    });

    const LogoSelfController = useCRUDController({
        apiRoute: "/system/user/token/log_self",
        onFinish,
        onBefore
    })
    const { width, height } = useWindowSize();

    useEffect(() => {
        checkAll();

    }, []);
    useEffect(() => {
        onSelectChange(selectedRowsInfo)
    }, [selectedRowsInfo])
    useEffect(() => {
        actionRef.current.reloadAndRest()
    }, [tableSearchParams])
    return (<Row gutter={[8, 8]}>
        <Col span={24}>
        </Col>
        <Col span={24}>
            <ProTableOt
                searchParams={{
                    ...tableSearchParams,
                }}
                formMode={true}
                actionRef={actionRef}
                headerTitle={
                    <>

                    </>
                }
                columns={showAllColumns ? columns : columns.filter((element) => {
                    return showColumns.includes(element?.key)
                })}
                check={check}
                setCheck={setCheck}
                rowKey={rowKey}

                toolBarRender={() => {
                    return [

                    ]
                }}
                extra_columns={extra_columns}
                set_extra_columns={set_extra_columns}
                manage_columns={false}
                request={async (params = {}, sort, filter) => {
                    let newParams = {};
                    let order = setOrders(sort);
                    let newTableSearchParams = { ...tableSearchParams }

                    newParams = {
                        ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                        ...newParams,
                        order,
                        size: params?.pageSize,
                        cur_page: params.current,
                        custom_filter_value: params.keyword ?? "",
                        custom_filter_key: custom_filter_key,
                        ...newTableSearchParams,
                    };
                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    setPageSize(params?.pageSize ?? 20);

                    return LogoSelfController.getData(newParams);
                }}
                pageSize={pageSize}
                rowSelection={false}

                propsPatchProcess={(data) => {
                    return {
                        ...data,
                        axiosMode: "patch"
                    }
                }}
                initialValues={{
                    "axiosMode": "post",
                }}
                propsPostOnBefore={(data) => {
                    return {
                        ...data,
                        axiosMode: "post"
                    }
                }}
                showMode="cardPage"  // page || infiniteScroll || card || cardPage,

                // PropsPatchForm={<NewArrivalsListForm />}
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                propsPatch={false}
                propsDelete={false}
                propsPost={false}
                propsWidth={2400}
                scroll={{
                    x: "100%",
                }}
                cardModeSetting={{
                    columnsCount: showCard[getBreakpoint(width)],
                    singleRowHeight: "100px",
                }}
                cardRender={(notification, { PatchButton, DeleteButton }) => {
                    return (
                        <Card

                            key={notification?.id}
                            className={`transition-all h-full ${!notification?.read ? "border-l-4 border-l-primary" : ""}`}
                        >
                            <CardContent className="p-4">
                                <div className="flex items-start gap-3">
                                    <div className="mt-1">{<Info className="h-5 w-5 text-blue-500" />}</div>
                                    <div className="flex-1 min-w-0">
                                        <div className="flex items-start justify-between gap-2">
                                            <h3 className={`font-medium ${!notification?.read ? "font-semibold" : ""}`}>
                                                {notification?.title}
                                            </h3>
                                            <span className=" text-muted-foreground whitespace-nowrap"><RelativeDateAndTime time={notification?.date_and_time} /> </span>
                                        </div>
                                        <p className=" text-muted-foreground mt-1 break-words whitespace-pre-wrap">
                                            {notification?.content}</p>
                                    </div>
                                </div>
                                {/* <div className="flex justify-end mt-2 gap-2">
                                    {!notification?.read && (
                                        <Button variant="ghost" size="sm" onClick={() => markAsRead(notification?.id)}>
                                            <Check className="h-4 w-4 mr-1" />
                                            標為已讀
                                        </Button>
                                    )}
                                </div> */}
                            </CardContent>
                        </Card>
                    )
                }}

            />
        </Col>
    </Row>)

}
const RelativeDateAndTime = ({ time }) => {
    const time1 = useRelativeTime(time, "zh"); // 昨天
    return <>
        {time1}
    </>
}
export default MessageInbox